import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'

import lang from './lang/lang.js'

export default contract({
  lang: array([
    lang
  ])
})
